export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5293.ab158862.jpg";